import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import { Grid, Typography, IconButton, Divider } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Cancel } from "@material-ui/icons";
import { Edit } from "react-feather";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));

export default function CustomizedInputs(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    watch,
    setValue,
    getValues,
  } = props;
  const classes = useStyles();
  const classesTablero = useStylesTablero();
  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];
  // const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");
  const [activarContrasena, setActivarContrasena] = useState(false);
  const handleChange = (event, value) => {
    setValue("rol", value);
  };
  const cambioProyecto = (e, value) => {
    setValue("proyecto", value);
  };
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={4} xs={4}>
        <TextField
          label="NOMBRE"
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.nombre)}
          helperText={errors.nombre}
          defaultValue={defaultItem.nombre}
          name="nombre"
          inputRef={register({
            required: { value: true, message: "Campo requerido" },
          })}
          className={classesTablero.field}
        />
      </Grid>
      <Grid item md={4} xs={4}>
        <TextField
          label="APELLIDO PATERNO"
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.apaterno)}
          helperText={errors.apaterno}
          defaultValue={defaultItem.apaterno}
          name="apaterno"
          inputRef={register({
            required: { value: true, message: "Campo requerido" },
          })}
          className={classesTablero.field}
        />
      </Grid>
      <Grid item md={4} xs={4}>
        <TextField
          label="APELLIDO MATERNO"
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.amaterno)}
          helperText={errors.amaterno}
          defaultValue={defaultItem.amaterno}
          name="amaterno"
          inputRef={register({
            required: { value: true, message: "Campo requerido" },
          })}
          className={classesTablero.field}
        />
      </Grid>
      <Grid item md={6} xs={4}>
        <TextField
          label="CORREO"
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.correo)}
          helperText={errors.correo}
          defaultValue={defaultItem.correo}
          name="correo"
          inputRef={register({
            required: { value: true, message: "Campo requerido" },
            pattern: { value: /^\S+@\S+$/i, message: "Formato incorrecto" },
          })}
          className={classesTablero.field}
        />
      </Grid>

      <Grid item md={6} xs={6}>
        <Autocomplete
          options={ctl.rol}
          getOptionLabel={(option) => option.nrol}
          getOptionSelected={(option, value) => option.idrol == value.idrol}
          onChange={handleChange}
          value={watch("rol")}
          size="small"
          renderInput={(params) => (
            <TextField
              label="ROL"
              variant="outlined"
              {...params}
              error={Boolean(errors.rol)}
              helperText={errors.rol}
              className={classesTablero.field}
            />
          )}
        />
      </Grid>
      <Grid item md={6} xs={6}>
        <TextField
          label="NOMBRE DE USUARIO"
          variant="outlined"
          fullWidth
          size="small"
          error={Boolean(errors.usuario)}
          helperText={errors.usuario}
          defaultValue={defaultItem.usuario}
          name="usuario"
          inputRef={register({
            required: { value: true, message: "Campo requerido" },
          })}
          className={classesTablero.field}
          inputProps={{
            autoComplete: "new-password",
          }}
        />
      </Grid>
      {defaultItem.idusuario == undefined ? (
        <Grid item md={6} xs={6}>
          <TextField
            label="CONTRASEÑA"
            variant="outlined"
            fullWidth
            size="small"
            type="password"
            error={Boolean(errors.password)}
            helperText={errors.password}
            defaultValue={defaultItem.password}
            name="password"
            inputRef={register({
              required: { value: true, message: "Campo requerido" },
            })}
            className={classesTablero.field}
            inputProps={{
              autoComplete: "new-password",
            }}
          />
        </Grid>
      ) : (
        <Grid item xs={6}>
          <Typography variant="button">Cambio de Contraseña</Typography>
          <IconButton
            onClick={(e) => setActivarContrasena(!activarContrasena)}
            size="small"
          >
            {activarContrasena ? (
              <Cancel className={classes.colorIconCancel} />
            ) : (
              <Edit className={classes.colorIcon} />
            )}
          </IconButton>
          <Divider />
        </Grid>
      )}
      {activarContrasena && (
        <React.Fragment>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              label="NUEVA CONTRASEÑA"
              error={Boolean(errors.password)}
              helperText={errors.password}
              name="password"
              inputRef={register({
                //required:{value:true,message:'Campo requerido'}
              })}
              type="password"
              className={classesTablero.field}
              inputProps={{
                autoComplete: "new-password",
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              size="small"
              label="CONFIRME CONTRASEÑA"
              error={Boolean(errors.pwd2)}
              helperText={errors.pwd2}
              name="pwd2"
              inputRef={register({
                validate: (value) => value === watch("password"),
              })}
              type="password"
              variant="outlined"
              className={classesTablero.field}
              inputProps={{
                autoComplete: "new-password",
              }}
            />
          </Grid>
        </React.Fragment>
      )}
      {getValues("rol")?.idrol == 6 && (
        <Grid item md={12} xs={12}>
          <Autocomplete
            multiple
            options={ctl.proyecto}
            getOptionLabel={(option) => option.nproyecto}
            getOptionSelected={(option, value) =>
              option.idproyecto == value.idproyecto
            }
            value={watch("proyecto") ? watch("proyecto") : undefined}
            onChange={cambioProyecto}
            size="small"
            fullWidth
            name="proyecto"
            renderInput={(params) => (
              <TextField
                label="Proyectos"
                variant="outlined"
                {...params}
                error={errors.proyecto != undefined}
                helperText={errors.proyecto}
                className={classesTablero.field}
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
}
